import { createKeyMap } from "./create-key-map";

export const createIdMap = <T extends { id: string }>(list: T[]) => {
  return createKeyMap(list, "id");
};
